import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Diyetisyen Nihal Kamış - KişİYE Özgü Diyet Plan Programı",
  description = "Diyetisyen Nihal Kamış'tan kişiye özgü diyet planları, beslenme danışmanlığı ve sağlıklı yaşam rehberleri.",
  name = "Diyetisyen Nihal Kamış",
  type = "website",
  url = "https://www.nihalkamis.com",
  image = "https://www.nihalkamis.com/assets/placeholder-dietitian.png",
  article = false,
  published = "",
  modified = "",
  author = "Diyetisyen Nihal Kamış",
  keywords = "diyetisyen, beslenme danışmanı, diyetisyen nihal kamış, diyet programı, kilo verme, kilo alma, sağlıklı beslenme, beslenme planı"
}) => {
  return (
    <Helmet>
      {/* Standard meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph meta tags for social media */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={name} />
      {published && <meta property="article:published_time" content={published} />}
      {modified && <meta property="article:modified_time" content={modified} />}
      {author && <meta property="article:author" content={author} />}
      
      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@NihalKamis" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "Diyetisyen Nihal Kamış",
          "description": "Diyetisyen Nihal Kamış'tan kişiye özgü diyet planları, beslenme danışmanlığı ve sağlıklı yaşam rehberleri.",
          "url": url,
          "image": image,
          "logo": "https://www.nihalkamis.com/logo192.png",
          "telephone": "",
          "email": "info@nihalkamis.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "",
            "addressLocality": "",
            "addressRegion": "",
            "postalCode": "",
            "addressCountry": "TR"
          },
          "areaServed": {
            "@type": "City",
            "name": "İstanbul"
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "09:00",
            "closes": "18:00"
          },
          "sameAs": [
            "https://www.instagram.com/nihalkamis",
            "https://www.facebook.com/nihalkamis"
          ],
          "provider": {
            "@type": "Person",
            "name": "Nihal Kamış",
            "jobTitle": "Diyetisyen",
            "image": "https://www.nihalkamis.com/assets/placeholder-dietitian.png",
            "alumniOf": {
              "@type": "CollegeOrUniversity",
              "name": "İstanbul Medipol Üniversitesi"
            },
            "hasCredential": {
              "@type": "EducationalOccupationalCredential",
              "credentialCategory": "Dietitian",
              "educationalLevel": "Bachelor's Degree"
            }
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;